import { ADSENSE_INLINE_ONLY, GOOGLE_ADS_ENABLED } from "@/components/nitro/config";

export type GamDisplaySize = [number, number] | "fluid";

export const ADS_CLIENT = (GOOGLE_ADS_ENABLED || ADSENSE_INLINE_ONLY) ? "ca-pub-7902170378611353" : "";

export const AD_LABEL_VISIBLE: "Advertisement" | "Sponsored link" | false =
  (process.env.NEXT_PUBLIC_AD_LABEL_VISIBLE as
    | "Advertisement"
    | "Sponsored link"
    | "false"
    | undefined) === "false"
    ? false
    : (process.env.NEXT_PUBLIC_AD_LABEL_VISIBLE as
        | "Advertisement"
        | "Sponsored link"
        | undefined) ?? "Advertisement";

export const AD_ARIA_LABEL =
  process.env.NEXT_PUBLIC_AD_ARIA_LABEL ?? "Advertisement";

export const FUNDING_CHOICES_SRC =
  process.env.NEXT_PUBLIC_FUNDING_CHOICES_SRC ?? "";

export const ADS_CONSENT_COOKIE = "bfc_ads_consent";
export const ADS_CONSENT_MAX_AGE = 60 * 60 * 24 * 365;

export const AD_SLOT_IDS = {
  homeMid: process.env.NEXT_PUBLIC_AD_SLOT_HOME_MID ?? "7121442152",

  levelTop: process.env.NEXT_PUBLIC_AD_SLOT_LEVEL_TOP ?? "9560949416",
  levelMid: process.env.NEXT_PUBLIC_AD_SLOT_LEVEL_MID ?? "1266323744",

  categoryTop: process.env.NEXT_PUBLIC_AD_SLOT_CATEGORY_TOP ?? "5704405391",

  baseHero: process.env.NEXT_PUBLIC_AD_SLOT_BASE_HERO ?? "6445769287",
  baseInline: process.env.NEXT_PUBLIC_AD_SLOT_BASE_INLINE ?? "6936262524",
  baseBottom: process.env.NEXT_PUBLIC_AD_SLOT_BASE_BOTTOM ?? "7576581220",
} as const;

export function hasAdSlot(slot: string | null | undefined): boolean {
  return typeof slot === "string" && slot.trim().length > 0;
}

export const GAM_NETWORK_CODE =
  process.env.NEXT_PUBLIC_GAM_NETWORK_CODE ?? "23352426316";

export const GAM_DISPLAY_ENABLED = GOOGLE_ADS_ENABLED && (
  process.env.NEXT_PUBLIC_GAM_DISPLAY_ENABLED === "true" ||
  (process.env.NODE_ENV === "production" &&
    process.env.NEXT_PUBLIC_GAM_DISPLAY_ENABLED !== "false"));

/** Opt-in: independently enable native GAM web interstitial without legacy GAM banners. */
export const GAM_WEB_INTERSTITIAL_ENABLED =
  process.env.NEXT_PUBLIC_GAM_WEB_INTERSTITIAL_ENABLED === "true";

export const GAM_INTERSTITIAL_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_INTERSTITIAL_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/interstitial_mobile`;

export const GAM_INTERSTITIAL_FALLBACK_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_INTERSTITIAL_FALLBACK_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/interstitial_mobile_fallback`;

export const GAM_ENABLED = GOOGLE_ADS_ENABLED && (
  (process.env.NEXT_PUBLIC_GAM_ENABLED === "true" ||
    (process.env.NODE_ENV === "production" &&
      process.env.NEXT_PUBLIC_GAM_ENABLED !== "false")) &&
  GAM_INTERSTITIAL_AD_UNIT.trim().length > 0);

export const GAM_BASE_TOP_MOBILE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_TOP_MOBILE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_top_mobile`;

export const GAM_BASE_TOP_MOBILE_ENABLED =  
  GAM_DISPLAY_ENABLED && GAM_BASE_TOP_MOBILE_AD_UNIT.trim().length > 0;

export const GAM_BASE_TOP_MOBILE_SIZES: ReadonlyArray<GamDisplaySize> = [
  [320, 100],
  [320, 50],  
];

export const GAM_BASE_ENTRY_MOBILE_SIZES: ReadonlyArray<GamDisplaySize> = [
  "fluid",
  [1, 1],
  [320, 320],
  [320, 480],
  [300, 600],
  [336, 280],
  [300, 250],
];

export const GAM_BASE_NAV_TOP_MOBILE_SIZES: ReadonlyArray<[number, number]> = [
  [320, 320],
  [320, 480],
  [300, 600],
  [336, 280],
  [300, 250],
];

export const GAM_HOME_INLINE_SIZES: ReadonlyArray<GamDisplaySize> = [
  [300, 600],
  [336, 280],
  [320, 480],
  [320, 320],
  [360, 360],
  [250, 460],
  "fluid",
];

export const GAM_CATEGORY_INLINE_SIZES: ReadonlyArray<[number, number]> = [
  [320, 100],
  [320, 50],
];

export const GAM_LEVEL_INLINE_SIZES: ReadonlyArray<[number, number]> = [
  [320, 100],
  [320, 50],  
];

export const GAM_BASE_TOP_MOBILE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_TOP_MOBILE_MIN_HEIGHT ?? "100"
);

export const GAM_BASE_ENTRY_MOBILE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_ENTRY_MOBILE_MIN_HEIGHT ?? "280"
);

export const GAM_BASE_NAV_TOP_MOBILE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_NAV_TOP_MOBILE_MIN_HEIGHT ?? "100"
);  

export const GAM_HOME_INLINE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_HOME_INLINE_MIN_HEIGHT ?? "600"
);

export const GAM_CATEGORY_INLINE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_CATEGORY_INLINE_MIN_HEIGHT ?? "100"
);

export const GAM_LEVEL_INLINE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_LEVEL_INLINE_MIN_HEIGHT ?? "100"
);

export const GAM_BASE_ENTRY_MOBILE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_ENTRY_MOBILE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_entry_mobile`;

export const GAM_BASE_ENTRY_MOBILE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_BASE_ENTRY_MOBILE_AD_UNIT.trim().length > 0;

export const GAM_BASE_NAV_TOP_MOBILE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_NAV_TOP_MOBILE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_nav_top_mobile`;

export const GAM_BASE_NAV_TOP_MOBILE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_BASE_NAV_TOP_MOBILE_AD_UNIT.trim().length > 0;


export const GAM_BASE_TABLET_BANNER_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_TABLET_BANNER_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_tablet_banner`;

export const GAM_BASE_TABLET_BANNER_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_BASE_TABLET_BANNER_AD_UNIT.trim().length > 0;

export const GAM_BASE_TABLET_BANNER_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [970,90],
];

export const GAM_BASE_TABLET_BANNER_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_TABLET_BANNER_MIN_HEIGHT ?? "100"
);

export const GAM_BASE_DESKTOP_BANNER_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_DESKTOP_BANNER_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_desktop_banner`;

export const GAM_BASE_DESKTOP_BANNER_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_BASE_DESKTOP_BANNER_AD_UNIT.trim().length > 0;

export const GAM_BASE_DESKTOP_BANNER_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [970, 90],
  [970, 250],
];

export const GAM_BASE_DESKTOP_BANNER_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_DESKTOP_BANNER_MIN_HEIGHT ?? "90"
);

export const GAM_CATEGORY_INLINE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_CATEGORY_INLINE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/category_mobile_inline`;

export const GAM_CATEGORY_INLINE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_CATEGORY_INLINE_AD_UNIT.trim().length > 0;

export const GAM_LEVEL_INLINE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_LEVEL_INLINE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/level_mobile_inline`;

export const GAM_LEVEL_INLINE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_LEVEL_INLINE_AD_UNIT.trim().length > 0;

export const GAM_HOME_INLINE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_HOME_INLINE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/home_mobile_inline`;

export const GAM_HOME_INLINE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_HOME_INLINE_AD_UNIT.trim().length > 0;

export const GAM_HOME_TABLET_BANNER_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_HOME_TABLET_BANNER_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/home_tablet_banner`;

export const GAM_HOME_TABLET_BANNER_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_HOME_TABLET_BANNER_AD_UNIT.trim().length > 0;

export const GAM_HOME_TABLET_BANNER_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [970, 90],
];

export const GAM_HOME_TABLET_BANNER_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_HOME_TABLET_BANNER_MIN_HEIGHT ?? "90"
);

export const GAM_HOME_TABLET_MID_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_HOME_TABLET_MID_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/home_tablet_mid_banner`;

export const GAM_HOME_TABLET_MID_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_HOME_TABLET_MID_AD_UNIT.trim().length > 0;

export const GAM_HOME_TABLET_MID_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [336, 280],
  [300, 250],
];

export const GAM_HOME_TABLET_MID_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_HOME_TABLET_MID_MIN_HEIGHT ?? "90"
);

export const GAM_HOME_DESKTOP_LEFT_RAIL_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_HOME_DESKTOP_LEFT_RAIL_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/home_desktop_left_rail`;

export const GAM_HOME_DESKTOP_RIGHT_RAIL_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_HOME_DESKTOP_RIGHT_RAIL_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/home_desktop_right_rail`;

export const GAM_HOME_DESKTOP_RAIL_ENABLED =
  GAM_DISPLAY_ENABLED &&
  GAM_HOME_DESKTOP_LEFT_RAIL_AD_UNIT.trim().length > 0 &&
  GAM_HOME_DESKTOP_RIGHT_RAIL_AD_UNIT.trim().length > 0;

export const GAM_HOME_DESKTOP_RAIL_SIZES: ReadonlyArray<[number, number]> = [
  [120, 600],
  [160, 600],
];

export const GAM_HOME_DESKTOP_RAIL_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_HOME_DESKTOP_RAIL_MIN_HEIGHT ?? "600"
);


export const GAM_LEVEL_WIDE_BANNER_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_LEVEL_WIDE_BANNER_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/level_wide_banner`;

export const GAM_LEVEL_WIDE_BANNER_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_LEVEL_WIDE_BANNER_AD_UNIT.trim().length > 0;

export const GAM_CATEGORY_WIDE_BANNER_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_CATEGORY_WIDE_BANNER_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/category_wide_banner`;

export const GAM_CATEGORY_WIDE_BANNER_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_CATEGORY_WIDE_BANNER_AD_UNIT.trim().length > 0;

export const GAM_HUB_WIDE_BANNER_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [970, 90],
  [970, 250],
];

export const GAM_HUB_WIDE_BANNER_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_HUB_WIDE_BANNER_MIN_HEIGHT ?? "90"
);

export const GAM_HOME_DESKTOP_BANNER_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_HOME_DESKTOP_BANNER_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/home_desktop_banner`;

export const GAM_HOME_DESKTOP_BANNER_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_HOME_DESKTOP_BANNER_AD_UNIT.trim().length > 0;

export const GAM_HOME_DESKTOP_BANNER_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [970, 90],
  [970, 250],
];

export const GAM_HOME_DESKTOP_BANNER_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_HOME_DESKTOP_BANNER_MIN_HEIGHT ?? "90"
);

export const GAM_EVENT_HERO_MOBILE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_EVENT_HERO_MOBILE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/event_hero_mobile_banner`;

export const GAM_EVENT_HERO_MOBILE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_EVENT_HERO_MOBILE_AD_UNIT.trim().length > 0;

export const GAM_EVENT_HERO_MOBILE_SIZES: ReadonlyArray<[number, number]> = [
  [320, 50],
  [320, 100],
];

export const GAM_EVENT_HERO_MOBILE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_EVENT_HERO_MOBILE_MIN_HEIGHT ?? "100"
);

export const GAM_EVENT_HERO_WIDE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_EVENT_HERO_WIDE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/event_hero_wide_banner`;

export const GAM_EVENT_HERO_WIDE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_EVENT_HERO_WIDE_AD_UNIT.trim().length > 0;

export const GAM_EVENT_HERO_WIDE_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [970, 90],
];

export const GAM_EVENT_HERO_WIDE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_EVENT_HERO_WIDE_MIN_HEIGHT ?? "90"
);

export const GAM_CWL_SLOT_MOBILE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_CWL_SLOT_MOBILE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/cwl_slot_mobile_inline`;

export const GAM_CWL_SLOT_MOBILE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_CWL_SLOT_MOBILE_AD_UNIT.trim().length > 0;

export const GAM_CWL_SLOT_MOBILE_SIZES: ReadonlyArray<[number, number]> = [
  [320, 50],
  [320, 100],
  [300, 250],
  [336, 280],
];

export const GAM_CWL_SLOT_MOBILE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_CWL_SLOT_MOBILE_MIN_HEIGHT ?? "100"
);

export const GAM_BASE_POST_CTA_MOBILE_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_POST_CTA_MOBILE_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_post_cta_mobile`;

export const GAM_BASE_POST_CTA_MOBILE_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_BASE_POST_CTA_MOBILE_AD_UNIT.trim().length > 0;

export const GAM_BASE_POST_CTA_MOBILE_SIZES: ReadonlyArray<[number, number]> = [
  [336, 280],
  [300, 250],
];

export const GAM_BASE_POST_CTA_MOBILE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_POST_CTA_MOBILE_MIN_HEIGHT ?? "280"
);

export const GAM_BASE_TABLET_MID_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_TABLET_MID_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_tablet_mid_banner`;

export const GAM_BASE_TABLET_MID_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_BASE_TABLET_MID_AD_UNIT.trim().length > 0;

export const GAM_BASE_TABLET_MID_SIZES: ReadonlyArray<[number, number]> = [
  [728, 90],
  [336, 280],
  [300, 250],
];

export const GAM_BASE_TABLET_MID_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_TABLET_MID_MIN_HEIGHT ?? "90"
);

export const GAM_BASE_DESKTOP_RIGHT_RAIL_AD_UNIT =
  process.env.NEXT_PUBLIC_GAM_BASE_DESKTOP_RIGHT_RAIL_AD_UNIT ??
  `/${GAM_NETWORK_CODE}/base_desktop_right_rail`;

export const GAM_BASE_DESKTOP_RIGHT_RAIL_ENABLED =
  GAM_DISPLAY_ENABLED && GAM_BASE_DESKTOP_RIGHT_RAIL_AD_UNIT.trim().length > 0;

export const GAM_BASE_DESKTOP_RIGHT_RAIL_SIZES: ReadonlyArray<[number, number]> = [
  [300, 600],
  [300, 250],
  [160, 600],
];

export const GAM_BASE_DESKTOP_RIGHT_RAIL_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_BASE_DESKTOP_RIGHT_RAIL_MIN_HEIGHT ?? "600"
);

export const GAM_MOBILE_INLINE_MIN_HEIGHT = Number(
  process.env.NEXT_PUBLIC_GAM_MOBILE_INLINE_MIN_HEIGHT ?? "600"
);

export type GamInterstitialSize = [number, number] | "fluid";

export const GAM_INTERSTITIAL_SIZES: ReadonlyArray<GamInterstitialSize> = [
  "fluid",
  [360, 360],
  [300, 600],
];

export const GAM_INTERSTITIAL_FALLBACK_SIZES: ReadonlyArray<GamInterstitialSize> = [
  "fluid",
  [360, 360],
  [300, 600],
];

export const INTERSTITIAL_MIN_NAVIGATIONS = Number(
  process.env.NEXT_PUBLIC_INTERSTITIAL_MIN_NAVIGATIONS ?? "2"
);

export const INTERSTITIAL_REPEAT_NAVIGATIONS = Number(
  process.env.NEXT_PUBLIC_INTERSTITIAL_REPEAT_NAVIGATIONS ?? "3"
);

export const INTERSTITIAL_COOLDOWN_MS = Number(
  process.env.NEXT_PUBLIC_INTERSTITIAL_COOLDOWN_MS ?? "60000"
);

export const INTERSTITIAL_REQUEST_TIMEOUT_MS = Number(
  process.env.NEXT_PUBLIC_INTERSTITIAL_REQUEST_TIMEOUT_MS ?? "4000"
);
